module.exports = __webpack_public_path__ + "img/hour@3x.1bca43c7.png";